import noUiSlider from "nouislider";
import LazyLoad from "vanilla-lazyload";
import Common from "./common";
import animate from "./animate";

const projects = {
  init: function () {
    // Checkboxes
    projects.checkboxes.init();

    // Sliders
    projects.sliders.init();

    // Filtering
    projects.filter.init();

    // Overlay
    projects.overlay.init();
  },

  checkboxes: {
    init: function () {
      $(".projects-filter__checkbox")
        .children("input")
        .each(function () {
          var el = $(this);
          projects.checkboxes.checkbox(el);
        });
      $(".projects-filter__checkbox input").on("change", function () {
        var el = $(this);
        projects.checkboxes.checkbox(el);
      });
    },
    checkbox: function (el) {
      var name = el.attr("name");
      if (el.is(":checked")) {
        $('.projects-filter__slider[data-name="' + name + '"]').fadeIn(250);
      } else {
        $('.projects-filter__slider[data-name="' + name + '"]').hide();
      }
    },
  },

  sliders: {
    init: function () {
      $(".projects-filter__checkbox input").on("change", function () {
        projects.filter.load();
      });
      $(".projects-filter__slider")
        .children("div")
        .each(function () {
          var el = $(this);
          projects.sliders.slider(el);
        });
    },
    slider: function (el) {
      var min, max;
      min = el.data("min");
      max = el.data("max");

      var type = el.parent().data("name");

      var pips = {};
      var format = {
        to: (v) => v | 0,
        from: (v) => v | 0,
      };
      var step = 1;
      if (type === "project-coefficient") {
        format = {
          to: (v) => v.toFixed(2),
          from: (v) => v,
        };
        step = 0.01;
      }
      switch (true) {
        case min == 0 && max <= 10:
          pips = {
            mode: "count",
            values: max + 1,
            density: 5,
            stepped: true,
          };
          break;
        case max <= 10:
          pips = {
            mode: "count",
            values: max,
            density: 5,
            stepped: true,
          };
          break;
        default:
          pips = {
            mode: "positions",
            values: [0, 25, 50, 75, 100],
            density: 5,
            stepped: true,
          };
      }
      noUiSlider.create(el[0], {
        range: {
          min: min,
          max: max,
        },
        start: [min, max],
        tooltips: true,
        step: step,
        pips: pips,
        format: format,
      });

      // set input val
      var input = el.siblings("input");
      el[0].noUiSlider.on("update", function (values, handle) {
        if (values.length > 0) {
          var string = JSON.stringify(values);
          input.val(string);
        }
      });

      // Load
      el[0].noUiSlider.on("change", function () {
        projects.filter.load();
      });
    },
  },

  filter: {
    loading: false,
    init: function () {
      // Name search
      $('.projects-filter__header input[name="project-name"]').on(
        "change",
        function () {
          projects.filter.load();
        }
      );

      // Pagination
      $("body").on("click", ".projects-pager button", function () {
        if (!projects.filter.loading) {
          var btn = $(this);
          var posts = $("#projects-grid");
          var page = +posts.attr("data-page");
          var total_pages = +posts.attr("data-pages");

          if (btn.hasClass("projects-pager__next")) {
            if (page < total_pages) {
              page++;
            }
          }
          if (btn.hasClass("projects-pager__prev")) {
            if (0 < page) {
              page--;
            }
          }

          posts.attr("data-page", page);

          projects.filter.load();
        }
      });
    },

    load: function () {
      var nonce = $("#nonce").val();
      var pager = $("#projects-pager");
      var dom_projects = $("#projects-grid");
      var page = dom_projects.attr("data-page");
      var terms = {};
      var name = $('.projects-filter__header input[name="project-name"]').val();

      // filter attributes
      $(".projects-filter .projects-filter__checkbox input").each(function () {
        var checkbox = $(this);
        var input = checkbox
          .closest(".projects-filter__box")
          .find(".projects-filter__slider input");
        if (checkbox.is(":checked")) {
          var name = input.attr("name");
          terms[name] = input.val();
        }
      });
      dom_projects.addClass("loading");
      pager.addClass("loading");
      // Loads data
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "filter_projects",
          page: page,
          name: name,
          terms: terms,
          nonce: nonce,
        },
        beforeSend: function (xhr) {
          projects.filter.loading = true;
          $("#projects-grid").addClass("loading");
        },
        success: function (response) {
          dom_projects.removeClass("loading");
          pager.removeClass("loading");
          if (response.success) {
            dom_projects.html(response.data.posts);
            pager.html(response.data.pager);
            Common.lazyLoadInstance.update();
          } else {
            console.log(response);
            dom_projects.html(response.data.message);
            pager.html("");
          }

          projects.filter.anim();
          setTimeout(function () {
            projects.filter.loading = false;
            animate.elements();
          }, 250);
        },
      });
    },

    anim: function () {
      if ($(window).width() < 899) {
        var projects = $("#projects-grid");
        var admin_bar_height = $("#wpadminbar").length
          ? $("#wpadminbar").height()
          : 0;
        var offset = $("header").height() + admin_bar_height;
        $("html,body").animate(
          {
            scrollTop: projects.offset().top - offset,
          },
          250
        );
      }
    },
  },

  overlay: {
    loading: false,

    init: function () {
      projects.overlay.read_more();

      // Navigate
      $(document).keydown(function (e) {
        var project_id;
        switch (e.keyCode) {
          case 37: // Left
            project_id = $(".project-overlay__prev").data("id");
            break;

          case 39: // Right
            project_id = $(".project-overlay__next").data("id");
            break;
        }
        if (project_id) {
          projects.overlay.load(project_id);
        }
      });

      // Load project overlay item
      $("body").on("click", ".project-item", function (e) {
        e.preventDefault();
        var project_id = $(this).data("id");
        var dom_overlay = $("#projects-overlay");

        if (project_id == dom_overlay.data("id")) {
          dom_overlay.addClass("overlay--open");
          $("html").addClass("no-scroll");
        } else {
          projects.overlay.load(project_id);
          $("html").addClass("no-scroll");
        }
      });

      // Load project overlay prev||next item
      $("body").on("click", ".project-overlay__nav", function (e) {
        e.preventDefault();
        var project_id = $(this).data("id");
        projects.overlay.load(project_id);
      });
    },

    load: function (project_id) {
      var dom_overlay = $("#projects-overlay");
      var nonce = $("#nonce").val();

      var terms = {};
      // filter attributes
      $(".projects-filter .projects-filter__checkbox input").each(function () {
        var checkbox = $(this);
        var input = checkbox
          .closest(".projects-filter__box")
          .find(".projects-filter__slider input");
        if (checkbox.is(":checked")) {
          var name = input.attr("name");
          terms[name] = input.val();
        }
      });

      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "project_overlay",
          project_id: project_id,
          terms: terms,
          nonce: nonce,
        },
        beforeSend: function (xhr) {
          projects.overlay.loading = true;
        },
        success: function (response) {
          projects.overlay.loading = false;

          if (response.success) {
            dom_overlay.find(".overlay__content").html(response.data.overlay);
            dom_overlay.addClass("overlay--open");
          } else {
            dom_overlay.find(".overlay__content").html("");
          }
        },
      });
    },

    read_more: function () {
      // Show first
      $(".overlay").each(function () {
        var overlay = $(this);
        var blocks = overlay.find(".width-900");

        if (blocks.length) {
          blocks.first().show().addClass("visible");
        }

        if (blocks.length > 1) {
          overlay.find(".read-more").removeClass("read-more--hidden");
        }
      });

      // Slide more
      $(".read-more").on("click", function (e) {
        e.preventDefault();
        var btn = $(this);
        var blocks = btn.parent().find(".width-900").not(".visible");

        if (blocks.length <= 1) {
          btn.fadeOut();
        }

        blocks.first().slideDown().addClass("visible");
      });
    },
  },
};

export default projects;
